import { render, staticRenderFns } from "./SearchRemoveIcon.vue?vue&type=template&id=f6784e30"
import script from "./SearchRemoveIcon.vue?vue&type=script&lang=js"
export * from "./SearchRemoveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports